import { useChannelMappings } from 'app/components/mapping-channels/useChannelMappings'
import { ChannelMappingsShadcnComponent } from 'app/components/mapping-channels/ChannelMappingsShadcnComponent'

export default function Channels(): React.ReactElement {
  const hookData = useChannelMappings()
  return <ChannelMappingsShadcnComponent {...hookData} />
}
